import { render } from "./MediaDanceHome.vue?vue&type=template&id=66a9d21c"
import script from "./MediaDanceHome.vue?vue&type=script&lang=js"
export * from "./MediaDanceHome.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\janhp\\Documents\\GitHub\\dance\\dance\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__